import React, { useEffect } from 'react';
import styles from '../../../../common/components/employees/CustomNode.module.css';
import { GroupViewModel } from '../../models/GroupTree';

export type Props = {
    searchValue: string;
    node: GroupViewModel;
    depth: number;
    isOpen: boolean;
    isSelected: boolean;
    onToggle: (id: GroupViewModel['id']) => void;
    onSelect: (node: GroupViewModel) => void;
};

export const GroupCustomNode = (props: Props) => {
    const handleToggle = () => {
        if (props.node.droppable) {
            props.onToggle(props.node.id);
        }
    };

    const handleSelect = () => props.onSelect(props.node);

    useEffect(() => {
        if (props.searchValue) {
            handleToggle();
        }
    }, [props.searchValue]);

    return (
        <div
            className={`tree-node ${styles.root} ${
                props.isSelected && props.isSelected
            } mb-1`}
        >
            <div
                className={`${styles.expandIconWrapper} ${
                    props.isSelected && styles.isSelected
                } ${props.isOpen && styles.isOpen}`}
            >
                {props.node.droppable && (
                    <div
                        id={props.node.id.toString()}
                        onClick={(e) => {
                            handleToggle();
                        }}
                    >
                        <i className='mdi mdi-chevron-right' />
                    </div>
                )}
            </div>

            <div className={'checked-custom'}>
                <input
                    className='form-check-input'
                    type='checkbox'
                    checked={props.isSelected}
                    onChange={() => {
                        // Permite seleccionar solo si está disponible
                        // Permite deseleccionar aunque no esté disponible
                        if (props.node.isAvailable || props.isSelected) {
                            handleSelect();
                        }
                    }}
                    disabled={!props.node.isAvailable && !props.isSelected}
                    style={{
                        cursor:
                            props.node.isAvailable || props.isSelected
                                ? 'pointer'
                                : 'not-allowed',
                    }}
                    title={
                        !props.node.isAvailable && !props.isSelected
                            ? 'Este grupo no está disponible para seleccionar'
                            : props.isSelected
                            ? 'Este grupo ya está en uso, pero puede ser removido'
                            : ''
                    }
                />
            </div>

            <div className='d-flex align-items-center '>
                <div style={{ paddingLeft: 5 }}>
                    {props.node.parent == 0 ? (
                        <img
                            src='/assets/images/menuBar/node_base.svg'
                            alt=''
                            style={{ width: 17 }}
                        />
                    ) : !props.node.droppable ? (
                        <i
                            className='mdi mdi-account '
                            style={{
                                color: '#9F9FA0',
                            }}
                        ></i>
                    ) : (
                        <i
                            className='mdi mdi-account-group text-black'
                            style={{
                                color: '#9F9FA0',
                            }}
                        ></i>
                    )}
                </div>

                <span
                    className='form-check-label'
                    style={{
                        textTransform: 'capitalize',
                        paddingLeft: 5,
                        lineHeight: 1.25,
                        color: props.node.isAvailable ? '#5D5D5D' : '#B0B0B0',
                        fontStyle: !props.node.isAvailable ? 'italic' : 'normal',
                    }}
                >
                    {props.node.text?.toLowerCase()}{' '}
                    {/* Comentario si el grupo está deshabilitado y no está seleccionado por el registro */}
                    {!props.node.isAvailable && !props.isSelected && (
                        <span
                            style={{
                                textTransform: 'initial',
                                color: '#5D5D5D',
                                marginLeft: '0.5rem',
                                fontStyle: 'italic',
                                fontSize: '0.85em',
                            }}
                        >
                            (Grupo asociado a otro flujo de aprobación)
                        </span>
                    )}
                </span>
            </div>
        </div>
    );
};
